module.exports = __webpack_public_path__ + "static/Rush-0ef78549aca9b3dfb16d68c014b442b1.jpg";